import React, {lazy} from 'react';
import PropTypes from 'prop-types';
import {useLocation} from 'react-router-dom';
import {isPublicRoute} from '../../AuthUtils';

const SSOAbbvieContainer = lazy(() =>
    import(/* webpackChunkName: "authSsoAbbvie" */ 'app/auth/abbvie/SsoAbbvieContainer')
);

export default function LazySsoAbbvieContainer({children}) {
    let location = useLocation();
    if (isPublicRoute(location.pathname)) {
        return children;
    }

    return <SSOAbbvieContainer>{children}</SSOAbbvieContainer>;
}

LazySsoAbbvieContainer.propTypes = {
    children: PropTypes.node,
};
